document.addEventListener('change', function(event) {
  const radio = event.target.closest('[data-eurodecants-variant-radio]');
  if (!radio) return;

  const form = radio.closest('.eurodecants-card-atc-form');
  if (!form) return;

  form.querySelector('[data-eurodecants-variant-id]').value = radio.value;

  const card = form.closest('.product-card');
  if (!card) return;

  const priceEl = card.querySelector('.price.s1pr');
  if (!priceEl) return;

  const price = radio.dataset.price || '';
  const comparePrice = radio.dataset.comparePrice || '';

  if (comparePrice) {
    priceEl.innerHTML = `<span class="old-price">${comparePrice}</span>&nbsp;${price}`;
  } else {
    priceEl.innerHTML = price;
  }
});

document.addEventListener('submit', async function(event) {
  const form = event.target.closest('.eurodecants-card-atc-form');
  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('.eurodecants-card-atc-button');
  if (button) button.disabled = true;

  try {
    const formData = new FormData(form);

    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    });

    if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
        document.querySelectorAll('#cart .l4ca > li.removing, #cart .l4ca > li.removing2').forEach(function(item) {
  item.remove();
});

      ajaxCart.load(false, true, false, true);
    }
  } finally {
    if (button) button.disabled = false;
  }
});

document.addEventListener('click', function(event) {
  const removeLink = event.target.closest('#cart a.remove');
  if (!removeLink) return;

  setTimeout(function() {
    document.querySelectorAll('#cart .l4ca > li.removing, #cart .l4ca > li.removing2').forEach(function(item) {
      item.remove();
    });

    if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
      ajaxCart.load(false, true, false, true);
    }
  }, 500);
});